import { CollectionDataCard } from "../../API/Collections";

export class AdminCreateCollection {
    name: string = "";
    title: string = "";
    collectionApi: string = "";
    cards: CollectionDataCard[] = [];
}